import { render, staticRenderFns } from "./logoSharp.vue?vue&type=template&id=4e418ef9&scoped=true&"
import script from "./logoSharp.vue?vue&type=script&lang=js&"
export * from "./logoSharp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e418ef9",
  null
  
)

export default component.exports